import { render, staticRenderFns } from "./VsButtonFile.vue?vue&type=template&id=39f7fc76&scoped=true&"
import script from "./VsButtonFile.vue?vue&type=script&lang=js&"
export * from "./VsButtonFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f7fc76",
  null
  
)

export default component.exports